import Toggle from 'components/Toggle';
import { useNotificationPermission } from 'providers/NotificationPermissionProvider';
import { useQuery } from '@apollo/client';
import { MY_NOTIFICATIONS_QUERY } from 'graphql/APICalls';
import { useNavigate } from 'react-router-dom'; 

import 'styles/Notifications.css';

export default function NotificationsPage() {
  
  const navigate = useNavigate();

  const { notificationsEnabled, toggleNotifications } = useNotificationPermission();
  const { data: notificationQuery } = useQuery(MY_NOTIFICATIONS_QUERY);

  return (
    <div className="auto-scrollbar">
    <div className="centerer activity-page-overlay">
      <div className="centered notifications-container">

        <div className="card">
          <div style={{display: 'flex', alignItems: 'center', gap: '1em', justifyContent: 'space-between'}}>
            <div>Notifications</div>
            <Toggle on={notificationsEnabled} setOn={toggleNotifications} height='1.25em' />
          </div>
        </div>

        {notificationQuery?.me?.notifications.map(notification => (

          notification.kind === 'GroupInvitationNotification' &&
          notification.invitation.status === 'joined' ?
          <div className="card" key={notification.id} onClick={() => {
            navigate(`/g/${notification.invitation.group.shortId}`);
          }}>
            <div className="notification-container">
              <div className="notification-text">
                <span>{notification.invitation.group.creator.name} invited you to join </span>
                <span style={{whiteSpace: 'nowrap'}}>{notification.invitation.group.name}</span>
              </div>
              <div className="notification-picture">
                <img src={notification.invitation.group.creator.picture.imageSrc} alt={notification.invitation.group.creator.name} />
              </div>
            </div>
          </div>

          : notification.kind === 'NewActivityNotification' ?
          <div className="card" key={notification.id} onClick={() => {
            navigate(`/t/${notification.activity.shortId}`)
          }}>
            <div className="notification-container">
              <div className="notification-text">
                <span>{notification.activity.creator.name} added a new tag: </span>
                <span style={{whiteSpace: 'nowrap'}}>{notification.activity.title}</span>
              </div>
              <div className="notification-picture">
                <img src={notification.activity.creator.picture.imageSrc} alt={notification.activity.creator.name} />
              </div>
            </div>
          </div>

          : notification.kind === 'JoinRequestNotification' ?
          <div className="card" key={notification.id} onClick={() => {
            navigate(`/t/${notification.joinRequest.activity.shortId}`)
          }}>
            <div className="notification-container">
              <div className="notification-text">
                <span>{notification.joinRequest.applicant.name} wants to join you for </span>
                <span style={{whiteSpace: 'nowrap'}}>{notification.joinRequest.activity.title}</span>
              </div>
              <div className="notification-picture">
                <img src={notification.joinRequest.applicant.picture.imageSrc} alt={notification.joinRequest.applicant.name} />
              </div>
            </div>
          </div>

          : notification.kind === 'JoinRequestApprovalNotification' &&
            notification.joinRequest.status === 'approved' ?
          <div className="card" key={notification.id} onClick={() => {
            navigate(`/t/${notification.joinRequest.activity.shortId}`)
          }}>
            <div className="notification-container">
              <div className="notification-text">
                <span>{notification.joinRequest.activity.creator.name} agreed for you to join {notification.joinRequest.activity.creator.pronouns.object} for </span>
                <span style={{whiteSpace: 'nowrap'}}>{notification.joinRequest.activity.title}!</span>
              </div>
              <div className="notification-picture">
                <img src={notification.joinRequest.activity.creator.picture.imageSrc} alt={notification.joinRequest.activity.creator.name} />
              </div>
            </div>
          </div>

          : null
        
        ))}

      </div>
    </div>
    </div>
  )
}